enum Auth {
  signup = '/signup',
  login = '/login',
  loginCallback = '/login/callback',
  logoutCallback = '/logout/callback',
}
export default Auth
